const Routes = {
  welcomePage: '/',
  loginPage: '/login-page',
  userProfile: '/login-page/user-profile',
  mainPage: '/main-page',
  userProfileUpdated: '/user-profile',
  calendarPage: '/calendar',
  workoutPage: '/workout',
  workoutSetupPage: '/workout/workout-setup',
  workoutExercises: '/workout/workout-exercises',
  workoutStartTraining: '/workout/workout-start-training',
  workoutFeedback: '/workout/workout-feedback',
  sleepPage: '/sleep-page',
  sleepTipsPage: '/sleep-page/sleep-tips',
  waterBalance: '/water-balance',
  waterChallenge: '/water-balance/challenge',
  waterChallengeOpen: '/water-balance/challenge/open',
  foodCategory: '/food-category',
  foods: (category) => `/food-category/${category}`,
  terms: '/terms',
  account: '/my-account',
}

export default Routes;